import type {
  RoadmapItemLongTerm,
  RoadmapItemShortTerm,
} from "@/services/api/types";
import * as Styled from "./styled";
import ExclamationCircle from "@assets/icons/icon-changed.svg?react";

type Props = {
  item: RoadmapItemShortTerm | RoadmapItemLongTerm;
  onClick: () => void;
};

const ItemCard = ({ item, onClick }: Props) => {
  const isClickable = Boolean(item.itemDetails?.trim());
  const isShortTermItem = (
    item: RoadmapItemShortTerm | RoadmapItemLongTerm,
  ): item is RoadmapItemShortTerm => "itemStatus" in item;

  return (
    <Styled.ItemCard
      onClick={isClickable ? onClick : undefined}
      $clickable={isClickable}
      aria-disabled={!isClickable}
    >
      <Styled.CardTitleContainer>
        {isShortTermItem(item) && (
          <Styled.ItemStatus $status={item.itemStatus}></Styled.ItemStatus>
        )}
        {item.name}
        <Styled.ChangeIcon>
          {isShortTermItem(item) && item.changeDescription && (
            <ExclamationCircle />
          )}
        </Styled.ChangeIcon>
      </Styled.CardTitleContainer>
    </Styled.ItemCard>
  );
};

export default ItemCard;
